import Vue from 'vue'
import { AclInstaller, AclCreate, AclRule } from 'vue-acl'
import router from './router'

Vue.use(AclInstaller)

// console.log(new AclRule('public').or('admin').and('inside').generate());

export default new AclCreate({
  initial: ['admin','public'],
  notfound: '/accessDenied',
  router,
  acceptLocalRules: true,
  globalRules: {
    isAdmin: new AclRule('admin'),
    // isPublic: new AclRule('*'),
    isPublic: new AclRule('public').generate(),
    isManage: new AclRule('manage').generate(),
    isUser: new AclRule('User').generate(),
    // isManage: new AclRule('manage').generate(),
    // isPublic: new AclRule('public').or('admin').generate(),
    // isLogged: new AclRule('user').and('inside').generate(),
    // isPricing: new AclRule('pricing').generate(),
    // isCampaign: new AclRule('campaign').generate(),
  }
})